import * as React from "react";
import { ThemeProvider, styled, useTheme } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import { BreakPointComp, } from "../../component/ColorSelector/BreakPointModule";
var BootstrapDialog = styled(Dialog)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2),
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1),
        },
        "& .MuiDialog-container": {
            height: "80% !important",
        },
    });
});
export var CustomizedDialogs = function (_a) {
    var openModal = _a.openModal, scaleBreakpoints = _a.scaleBreakpoints, scaleData = _a.scaleData, customScalesName = _a.customScalesName;
    var _b = React.useState(true), openDialog = _b[0], setOpen = _b[1];
    var handleClose = function () {
        setOpen(false);
        openModal(false);
    };
    var _c = React.useState(scaleData), colorScaleBreakpoints = _c[0], setColorScaleBreakpoints = _c[1];
    var editedBreakpoint = React.useCallback(function (data) {
        setColorScaleBreakpoints(data);
        scaleBreakpoints(data);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setColorScaleBreakpoints, colorScaleBreakpoints]);
    var theme = useTheme();
    return (React.createElement("div", null, openDialog && (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(BootstrapDialog, { onClose: handleClose, "aria-labelledby": "customized-dialog-title", open: openDialog },
            React.createElement(BreakPointComp, { colorScaleBreakpoints: colorScaleBreakpoints, setColorScaleBreakpoints: setColorScaleBreakpoints, editedBreakpoint: editedBreakpoint, customScalesName: customScalesName }))))));
};
//# sourceMappingURL=Modal.js.map